import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { useGame } from '@/app/providers/GameContextProvider';
import { useGlobalPopup } from '@/app/providers/GlobalPopupProvider';
import { useGameModeSettingsContext } from '@/app/providers/GameModeSettingsProvider';
import InputFFXIV from '../../../InputFFXIV';

const RoundsSelector: React.FC = () => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { showPopup } = useGlobalPopup();
    const { settings, updateSetting, isGameMaster } = useGameModeSettingsContext();

    if (!room || !gameState) return null;

    const value = settings.maxRounds;

    const handleRoundChange = (newRounds: number) => {
        if (isGameMaster) {
            updateSetting('maxRounds', newRounds);
        } else {
            showPopup({
                type: 'error',
                message: t('lobby.onlyGameMasterCan'),
            });
        }
    };

    return (
        <div className="flex gap-3 items-center">
            <div className="text-[#EEE1C5] text-shadow-border shadow-black text-lg">
                {t('game.config.advancedSettings.rounds')}
            </div>
            <InputFFXIV
                value={value}
                onChange={(newValue) => handleRoundChange(newValue)}
                min={1}
                max={20}
                className="!w-[40px]"
            />
        </div>
    );
};

export default RoundsSelector;